import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';

import { isPortrait } from '../../utils/size';

const ContainerNormal = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;

const ImageNormal = styled.img`
    border-radius: 50%;
    max-height: ${props => props.size};
    object-fit: cover;
    object-position: center;
    height: ${props => props.size};
    width: ${props => props.size};
    max-width: ${props => props.size};
`;

export const RoundImage = props => (
    <ContainerNormal>
        <ImageNormal
            src={props.src}
            size={() => {
                if (props.size) {
                    return props.size;
                } else if (isPortrait() && props.isLongText) {
                    return `90px`;
                } else if (isPortrait()) {
                    return `105px`;
                } else {
                    return `120px`;
                }
            }}
            onError={e => (e.target.src = DefaultRepImageURL)}
        />
    </ContainerNormal>
);

RoundImage.propTypes = {
    src: PropTypes.any.isRequired,
    isLongText: PropTypes.bool,
    size: PropTypes.string
};

export default RoundImage;
